import { Modal } from 'components/Modal/Modal';
import React, { useEffect } from 'react';
import { useAppDispatch } from 'store';
import { closeModal, openModal } from 'store/modals/slice';
import styles from './Guide.module.scss';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { guideOptions } from './config/guideOptions';
import { ModalTypes } from 'configs/types';
import PreviewSkeleton from 'components/global/Skeleton/PreviewSkeleton/PreviewSkeleton';

type Props = {};

export const GuideModal: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [contentTitle, setContentTitle] = React.useState<string>('');
  const [contentLink, setContentLink] = React.useState<string>('');
  const [isLoading, setIsLoading] = React.useState(true);

  const handleCloseClick = () => {
    navigate(`${location.pathname}`);
    dispatch(closeModal());
  };

  useEffect(() => {
    const guideType = searchParams.get('type') ?? '';

    if (!guideOptions[guideType]) {
      navigate(`${location.pathname}`);
      dispatch(openModal({ activeModal: ModalTypes.premium }));

      return;
    }
    setIsLoading(true);
    setContentTitle(guideOptions[guideType].title);
    setContentLink(guideOptions[guideType].url);

  }, [searchParams]);

  const renderContent = () => {
    return (
      <iframe
        src={contentLink}
        title={contentTitle}
        onLoad={() => setIsLoading(false)}
      />
    );
  };

  return (
    <Modal onClose={handleCloseClick} className={styles["guide-modal"]}>
      <Modal.Header className={styles["guide-header"]} />
      <Modal.Content className={styles["guide-modal-content"]}>
        {isLoading && <PreviewSkeleton />}
        {renderContent()}
      </Modal.Content>
    </Modal>
  );
};
